import { createContext, useContext } from "react";
import useSnackbar from "../hooks/useSnackbar";

export const SnackbarContext = createContext();

export const useSnackbarContext = () => {
  return useContext(SnackbarContext);
};

export const Snackbar = ({ children }) => {
  const { handleSnackbar, SnackbarFeedback } = useSnackbar();

  return (
    <SnackbarContext.Provider value={{ handleSnackbar }}>
      {SnackbarFeedback}
      {children}
    </SnackbarContext.Provider>
  );
};
